import { reactive } from "vue"

const state = reactive({
  userInfo: {
    id: null,
    user_id: null,
    username: "",
    name: "",
    display_name: "",
    email: "",
    avatar: "",
    apply_to: [],
    roles: [],
    permissions: [],
  },
})

export function getUser() {
  return { ...state.userInfo }
}

export function setUser(value) {
  state.userInfo = value
}

export function useUser() {
  return {
    state,
    getUser,
    setUser,
  }
}
